import { type HydrateWidgetFn } from '@framework/engine/hydrate/IHydrationContext.ts';
import { get } from 'lodash';
import { competenceSelectWidgetLabelName } from './createCompetenceSelectFormSchema.ts';
import { type ICompetenceWidget } from './ICompetenceWidget.ts';

/**
 * L'idratazione del campo competenza non ritorna il suo ID ma la sua
 * descrizione (label) salvata in un campo interna apposito.
 */
export const hydrateCompetenceWidget: HydrateWidgetFn<ICompetenceWidget> = ({
  context,
  path,
}) => {
  const value = get(context.values, competenceSelectWidgetLabelName(path));

  return {
    // Se il valore è undefined, non sovrascrivo il valore precedente
    value: value ?? undefined,
  };
};
